import React, {Fragment, useContext} from 'react';
import ErrorContext from '../contexts/ErrorContext'
import Waypoint from './Waypoint'
import {distanceWithUiUnit} from '../data-source/prefs'

const EventTools = ({event,enableAdminTools,saveEventHandler,deleteEventHandler}) => {

    const error = useContext(ErrorContext)

    const hideBlock = () => {
        saveEventHandler(event.id,{hidden: !event.hidden, assigneeIds: []})
    }

    const eventHasError = error && (error.code==="rest_cannot_delete" || error.code==="rest_cannot_edit")
    const errorMessage = eventHasError ? <div style={{width: "100%", backgroundColor: "darkred", color: "white"}}>{error.message}</div> : <Fragment/>

    const waypointComponents = !Array.isArray(event.waypoints) ? <Fragment/> :
    event.waypoints.map( waypoint => <li><Waypoint data={waypoint}/> </li>)

    return(
        <div style={{width: "100%", marginTop: "24px"}}>
            {errorMessage}
            {enableAdminTools ? 
            <div style={{display: "grid", gridGap: "20px 20px", gridTemplateColumns: "repeat(auto-fill, minmax(150px , 1fr))", marginTop: "20px"}}>
                <button type="button" className="btn btn-warning btn-sm" onClick={hideBlock}>{event.hidden ? "Unhide Block" : "Hide Block"}</button>
                <button type="button" className="btn btn-warning btn-sm" onClick={() => deleteEventHandler(event.id)}>Revert to Raw Data</button>
            </div> 
            : <Fragment/>}

            <div style={{marginTop: "24px"}}>
            <div>Approx Distance: {event.distance ? distanceWithUiUnit(event.distance) : ''}</div>
                <ul>
                    {waypointComponents}
                </ul>
            </div>           
        </div>
    )

}

export default EventTools;